//  Form row
// =========

import React, { ReactNode } from 'react'
import PropTypes from 'prop-types'
import Label from './label'
import style from './row.scss'
import FieldSize, { fieldSizeDefaultProps } from '../form/fieldsize'
import cx from 'classnames'

interface RowProps {
  className?: string
  children: ReactNode
  label?: string
  labelClassname?: string
  wrapperClassName?: string
  size?: string
}

const Row = ({
  className,
  children,
  label,
  labelClassname,
  wrapperClassName,
  size,
  ...restProps
}: RowProps) => {
  const classNames = cx(style.Row, className, {
    [style.RowDefault]: size === FieldSize.DEFAULT,
    [style.RowSmall]: size === FieldSize.SMALL
  })

  return (
    <div className={cx(style.rowWrapper, wrapperClassName)} {...restProps}>
      {label && <Label className={labelClassname}>{label}</Label>}
      <div className={classNames}>{children}</div>
    </div>
  )
}

Row.propTypes = {
  className: PropTypes.string,
  labelClassname: PropTypes.string,
  wrapperClassName: PropTypes.string,
  label: PropTypes.string,
  children: PropTypes.node
}

Row.defaultProps = {
  ...fieldSizeDefaultProps
}

export default Row
